<template>
  <span
    class="dui-rating rating"
    :class="{ 'read-only': !editable }"
    :title="(currentValue + '/' + count)"
    @mouseout="mouseOutPerformed()"
  >
    <span
      v-for="n in count"
      :key="n"
      :class="{ 'star-full': (n <= currentValue),
                'star-empty': (!currentValue || n > currentValue) }"
      @click="valueSelected(n)"
      @mouseover="mouseOverPerformed(n)"
    />
  </span>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 5,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    vm: {
      hoverValue: null,
      storedValue: null,
    },
  }),
  computed: {
    currentValue() {
      return this.vm.hoverValue ? this.vm.hoverValue : this.vm.storedValue;
    },
  },
  watch: {
    value: function() {
      this.vm.storedValue = this.value;
    },
  },
  mounted() {
    this.vm.storedValue = this.value;
  },
  methods: {
    mouseOverPerformed(value) {
      if (!this.editable) {
        return;
      }

      this.vm.hoverValue = value;
      this.$emit('mouse-over-performed', value);
    },
    mouseOutPerformed() {
      if (!this.editable) {
        return;
      }

      this.vm.hoverValue = null;
      this.$emit('mouse-out-performed');
    },
    valueSelected(value) {
      if (!this.editable) {
        return;
      }

      this.vm.storedValue = value;
      this.$emit('input', this.vm.storedValue);
      this.$emit('change');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-rating {
  &[disabled] {
    opacity: $disabled-opacity;
  }

  &[disabled],
  &.read-only {
    cursor: default;
    pointer-events: none;
  }

  .star-empty,
  .star-full {
    cursor: pointer;
  }
}
</style>
